import { createFileRoute } from '@tanstack/react-router';
import { Heading } from '@osd/ui/heading';
import { Stack } from '@osd/ui/stack';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/heading — live docs for the `Heading` primitive.
 */
export const Route = createFileRoute('/ui/_layout/heading')({
  component: HeadingPage,
});

function HeadingPage() {
  return (
    <Stack gap={6}>
      <Section title="Heading" hint="semantic h1–h6 with consistent type scale">
        <Stack gap={2}>
          <Heading level={1}>h1 — Page title</Heading>
          <Heading level={2}>h2 — Section title</Heading>
          <Heading level={3}>h3 — Subsection</Heading>
          <Heading level={4}>h4 — Group label</Heading>
          <Heading level={5}>h5 — Minor label</Heading>
          <Heading level={6}>h6 — Smallest</Heading>
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Page title (h1)"
            language="tsx"
            code={`<Heading level={1}>Account settings</Heading>`}
          />

          <CodeBlock
            title="Section title (h2) — most common"
            language="tsx"
            code={`<Heading level={2}>Notifications</Heading>`}
          />

          <CodeBlock
            title="With a muted subtitle"
            language="tsx"
            code={`<>
  <Heading level={2}>Notifications</Heading>
  <Text muted>Choose what we email you about.</Text>
</>`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
